import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class PricingSection extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div id="pricing" className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Combien ça coûte ?</h2>
            <h5 className={classes.description}>
              Nous vous proposons des tarifs simples et accessibles avec notamment une offre gratuite.
              <br/>
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <CardHeader color="success">A la demande</CardHeader>
                <CardBody>
                  <h2 className={classes.cardTitle}>
                    Entre 4,99€ et 8,99€
                  </h2>
                  <p>
                    Trouvez votre transport uniquement quand vous en avez besoin
                    <br/>&nbsp;
                  </p>
                  <Button
                    color="rose"
                    href="/https://docs.google.com/forms/d/e/1FAIpQLScZPAt2AsC4j0RgIHmoLFa_Wx7h5yRe7aAQJSHz_X2HOkLPKQ/viewform"
                  >
                    Trouver
                  </Button>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <CardHeader color="warning">A la carte</CardHeader>
                <CardBody>
                  <h2 className={classes.cardTitle}>
                    Entre 9,99€ et 19,99€
                  </h2>
                  <p>
                    Choisissez vos quotas entre 3 et 10 trajets mensuelles sans débourser plus
                    <br/>&nbsp;
                  </p>
                  <Button
                    color="rose"
                    href="/https://docs.google.com/forms/d/e/1FAIpQLScZPAt2AsC4j0RgIHmoLFa_Wx7h5yRe7aAQJSHz_X2HOkLPKQ/viewform"
                  >
                    Commander
                  </Button>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <CardHeader color="danger">Abonnement</CardHeader>
                <CardBody>
                  <h2 className={classes.cardTitle}>
                    Prix unique de 29,99€ / mois
                  </h2>
                  <p>
                    Besoin d'un transport quotidien ? Optez pour l'abonnement et assurez-vous d'avoir
                    une disponibilité adapatée à vos besoins.
                  </p>
                  <Button
                    color="rose"
                    href="/https://docs.google.com/forms/d/e/1FAIpQLScZPAt2AsC4j0RgIHmoLFa_Wx7h5yRe7aAQJSHz_X2HOkLPKQ/viewform">
                    M'abonner
                  </Button>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(PricingSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/PricingSection.jsx